import BaseStyle from '@primevue/core/base/style';

var BaseComponentStyle = BaseStyle.extend({
  name: 'common'
});

export { BaseComponentStyle as default };
//# sourceMappingURL=index.mjs.map
